<template>
	<div class="shop">
		<!-- banner - 匹配 lz_project store 绿色系横幅 -->
		<div class="searchbanner">
			<div class="banner-content">
				<div class="banner-left">
					<h1 class="banner-title">法规标准库</h1>
					<p class="banner-subtitle">特种设备行业标准、规范、法规全覆盖检索</p>
				</div>
				<div class="banner-right">
					<p class="banner-desc">北京品读文化深耕特种设备行业20年，为特规通提供正版合规的法规标准图书资源支持。</p>
				</div>
			</div>
		</div>

		<div class="dataList">
			<el-row :gutter="20">
				<el-col :span="6">
					<SearchBox
						ref="SearchBoxRef"
						:searchTotal="totals"
						:statusList="statusList"
						@stanCheck="handleStanCheck"
						@statusCheck="handleStatusCheck"
						@pdfReadCheck="handlePdfReadCheck"
						@aiCheck="handleAICheck"
						@isBuyCheck="handleIsBuyCheck"
						@resetcheck="handleResetcheck"
						@categoryCheck="handleCategoryCheck"
					></SearchBox>
				</el-col>
				<el-col :span="18">
					<SearchBanner @itypeCheck="handleItypeCheck" @reset="handleReset" @showProduct="handleShowProduct" @queryType="handleQueryType" ref="SearchBannerRef"></SearchBanner>
					<Booklist
						ref="listbox"
						:dataList="dataList"
						:pageNum="searchParams.pageNum"
						:pageSize="searchParams.pageSize"
						:searchValue="searchParams.searchValue"
						:standardCode="searchParams.standardCode"
						:standardName="searchParams.standardName"
						:totals="totals"
						:showProduct="showProduct"
						:lifeList="statusList"
						:standardTypeList="standardTypeList"
						@changepage="handleChangepage"
						@sizeChange="handleSizeChange"
					></Booklist>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
	import utils from '@/utils/utils';
	import SearchBanner from '@/components/SearchBanner/index.vue';
	import SearchBox from './components/Search.vue';
	import Booklist from './components/Booklist.vue';
	import { getAllStandardBasicInfo, getNormStandardBasicInfo, getNormStandardBasicInfoByFull } from '@/api/standards/list';
	import { getStandardLife, getStandardType } from '@/api/standards/search';
	import { mapActions, mapGetters } from 'vuex';
	import EReg from '@/utils/EReg';

	export default {
		name: 'StandardsList',
		data() {
			return {
				searchParams: {
					searchValue: '',
					issueAgency: '',
					underAgency: '',
					issueBegin: '',
					issueEnd: '',
					effectiveBegin: '',
					effectiveEnd: '',
					itype: 0,
					standardName: '',
					standardCode: '',
					icsIdentify: '',
					ccsIdentify: '',
					replaceCode: '',
					headAgency: '',
					draftInfo: '',
					standardDomain: '',
					pageNum: 1,
					pageSize: 10,
					lifeId: [],
					standardType: [],
					categoryId: [],
					productTypeId: [],
					aiHad: null,
					readTypeId: [],
					queryType: 1
				},
				showProduct: false,
				dataList: [],
				totals: 0,
				requestSeq: 0, // 请求序列号，防止快速切换条件导致结果错乱
				tagColor: ['tagblue', 'tagred', 'taggreen', 'tagpurple', 'tagyellow', 'tagcyan', 'tagpink', 'taggray', 'tagblue'],
				grandData: {}, // 存储子组件快速检索传递过来的数据
				adGranddata: {}, // 存储子组件高级检索传递过来的数据
				categoryType: 1,
				statusList: [], // 存储实施状态字典
				standardTypeList: [] // 存储标准类型字典
			};
		},

		provide() {
			return {
				// 快速检索接受参数
				updateGrandData: data => {
					this.handleFastsearch(data);
				},
				// 高级检索接受参数
				updateAdgrandData: data => {
					this.handleAdsearch(data);
				},

				//全国标准库检索
				updateAdgrandNormData: data => {
					this.handleAdNormsearch(data);
				},

				// 清空左侧 SearchBox 所有筛选条件
				clearLeftSearchBox: () => {
					if (this.$refs.SearchBoxRef) {
						this.$refs.SearchBoxRef.clearAllSelections();
					}
					this.resetSearchBoxParams();
				}
			};
		},

		components: {
			SearchBanner,
			SearchBox,
			Booklist
		},

		created() {
			// 从首页搜索框跳转带来的 keyword
			if (this.$route.query.keyword) {
				this.searchParams.searchValue = this.$route.query.keyword;
			}
			this.getStandardLife();
			this.getStandardType();
			this.getAllStandardBasicInfo();
		},

		methods: {
			// 是否显示商品信息
			handleShowProduct(val) {
				this.showProduct = val;
			},

			// 是否显示全国标准库
			handleQueryType(val) {
				this.searchParams.queryType = val;
				this.searchParams.pageNum = 1;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},

			// 滚动到dataList顶部
			scrollToDataList() {
				this.$nextTick(() => {
					const dataListElement = document.querySelector('.dataList');
					if (dataListElement) {
						const elementRect = dataListElement.getBoundingClientRect();
						const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
						const targetPosition = elementRect.top + scrollTop - 90;

						window.scrollTo({
							top: targetPosition,
							behavior: 'smooth'
						});
					}
				});
			},
			// 设置载入
			_setLoading(to) {
				if (this.$refs.listbox) {
					this.$refs.listbox.setLoading(to);
				}
			},
			//分页
			handleChangepage(val) {
				this.searchParams.pageNum = val;
				this.getAllStandardBasicInfo();
				this.scrollToDataList();
			},
			handleSizeChange(val) {
				this.searchParams.pageSize = val;
				this.getAllStandardBasicInfo();
				this.scrollToDataList();
			},
			//标准类型检索
			handleCategoryCheck(val) {
				this.searchParams.pageNum = 1;
				this.searchParams.categoryId = val;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},
			handleStanCheck(val) {
				this.searchParams.pageNum = 1;
				this.searchParams.standardType = val;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},
			//标准状态检索
			handleStatusCheck(val) {
				this.searchParams.pageNum = 1;
				this.searchParams.lifeId = val;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},
			//快速检索
			handleFastsearch(val) {
				this.searchParams = { ...this.searchParams, ...val };
				this.searchParams.pageNum = 1;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},
			//高级检索
			handleAdsearch(val) {
				this.searchParams = { ...this.searchParams, ...val };
				this.searchParams.pageNum = 1;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},

			handleIsBuyCheck(val) {
				this.searchParams.pageNum = 1;
				this.searchParams.productTypeId = val;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},

			handlePdfReadCheck(val) {
				this.searchParams.pageNum = 1;
				this.searchParams.readTypeId = val;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},
			handleAICheck(val) {
				// console.log(val);
				this.searchParams.pageNum = 1;
				if (val.length > 0) {
					this.searchParams.aiHad = 1;
				} else {
					this.searchParams.aiHad = null;
				}
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},

			handleResetcheck(val) {
				this.searchParams = { ...this.searchParams, ...val };
				this.searchParams.pageNum = 1;
				if (this.categoryType == 1) {
					this.getAllStandardBasicInfo();
				} else {
					this.getNormStandardBasicInfo();
				}
			},

			//全部/特种设备检索
			handleItypeCheck(val) {
				this.categoryType = val;
				//重置检索条件
				this.resetSearchBannerParams();
				this.resetSearchBoxParams();
				this.searchParams.pageNum = 1;
				this.searchParams.pageSize = 10;
				this.$refs.SearchBannerRef.resetSearchParams();
				this.$refs.SearchBoxRef.clearAllSelections();
				this.$refs.SearchBoxRef.getTypeList(val);
				if (this.categoryType == 1) {
					// this.searchParams.industryId = [1];
					this.getAllStandardBasicInfo();
				} else {
					// this.searchParams.industryId = [];
					this.getNormStandardBasicInfo();
				}
			},

			//重置SearchBanner参数
			resetSearchBannerParams() {
				this.searchParams.searchValue = '';
				this.searchParams.standardName = '';
				this.searchParams.standardCode = '';
				this.searchParams.icsIdentify = '';
				this.searchParams.ccsIdentify = '';
				this.searchParams.replaceCode = '';
				this.searchParams.headAgency = '';
				this.searchParams.draftInfo = '';
				this.searchParams.standardDomain = '';
				this.searchParams.issueAgency = '';
				this.searchParams.underAgency = '';
				this.searchParams.issueBegin = '';
				this.searchParams.issueEnd = '';
				this.searchParams.effectiveBegin = '';
				this.searchParams.effectiveEnd = '';
				this.searchParams.itype = 0;
			},

			//重置SearchBox参数
			resetSearchBoxParams() {
				this.searchParams.lifeId = [];
				this.searchParams.standardType = [];
				this.searchParams.readTypeId = [];
				this.searchParams.aiHad = null;
				this.searchParams.productTypeId = [];
				this.searchParams.categoryId = [];
				this.searchParams.queryType = 1;
			},

			//获取图书列表--特种设备
			async getAllStandardBasicInfo() {
				const seq = ++this.requestSeq;
				this._setLoading(true);
				this.dataList = [];
				this.totals = 0;
				let res = null;
				//if this.searchParams.itype == 0 调用下面接口，如果是1调用getNormStandardBasicInfoByFull接口
				if (this.searchParams.itype == 0) {
					res = await getAllStandardBasicInfo(this.searchParams);
				} else {
					res = await getNormStandardBasicInfoByFull(this.searchParams);
				}
				// 如果不是最新请求，丢弃结果
				if (seq !== this.requestSeq) return;
				if (res.data === null) {
					this.dataList = [];
					this.totals = 0;
				} else {
					const { rows, totalNum } = res.data;
					this.dataList = rows || [];
					this.dataList.forEach(item => {
						if (item.standardSummary) {
							item.standardSummary = EReg.renderedFormula(EReg.removeNewlinesInLatexFormulas(item.standardSummary));
						}
						if (item.standardScope) {
							item.standardScope = item.standardScope.replace(/<br\s*\/?>/g, '');
							item.standardScope = EReg.renderedFormula(EReg.removeNewlinesInLatexFormulas(item.standardScope));
						}

						// 根据lifeId匹配修改lifeName的值
						this.formatterLifeName(item);
					});
					this.totals = Number(totalNum) || 0;
				}
				this._setLoading(false);
			},

			async getStandardLife() {
				let res = await getStandardLife();
				if (res.code == 200) {
					this.statusList = res.data;
					//去掉 暂不更新  和   废止转行标
					this.statusList = this.statusList.filter(item => item.id !== 9 && item.id !== 6);
				}
			},
			
			async getStandardType() {
				let res = await getStandardType();
				if (res.code == 200) {
					this.standardTypeList = res.data;
				}
			},
			
			//异步fomatterLifeName
			formatterLifeName(row) {
				if (row.lifeId && this.statusList.length > 0) {
					const statusItem = this.statusList.find(status => status.id === row.lifeId);
					if (statusItem) {
						row.lifeName = statusItem.lifeName;
					}
				}
			},

			//获取图书列表--全国标准
			async getNormStandardBasicInfo() {
				const seq = ++this.requestSeq;
				this._setLoading(true);
				this.dataList = [];
				this.totals = 0;
				const res = await getNormStandardBasicInfo(this.searchParams);
				// 如果不是最新请求，丢弃结果
				if (seq !== this.requestSeq) return;
				if (res.data === null) {
					this.dataList = [];
					this.totals = 0;
				} else {
					const { rows, totalNum } = res.data;
					this.dataList = rows || [];
					this.dataList.forEach(item => {
						if (item.standardScope) {
							item.standardScope = item.standardScope.replace(/<br\s*\/?>/g, '');
						}
					});
					this.totals = Number(totalNum) || 0;
				}
				this._setLoading(false);
			},

			//全国标准库检索
			handleAdNormsearch(val) {
				this.searchParams = { ...this.searchParams, ...val };
				this.searchParams.pageNum = 1;
				this.getNormStandardBasicInfo();
			},

			//处理重置按钮点击事件
			handleReset() {
				// 清空 SearchBox 的所有选中值
				if (this.$refs.SearchBoxRef) {
					this.$refs.SearchBoxRef.clearAllSelections();
				}
			},

			//重置左边栏条件
			handleResetcheck() {},

			// 处理statusList更新
			handleUpdateStatusList(statusList) {
				this.statusList = statusList;
			}
		},
		computed: {
			...mapGetters('Settings', ['resetStandardsList']),
			...mapGetters('User', ['uisLogin', 'cinfo'])
		},
		watch: {
			resetStandardsList(newVal, oldVal) {
				// console.log('监听是否重置查询条件--点击导航栏', newVal);
				if (newVal) {
					this.$nextTick(() => {
						// console.log('点击导航栏---重置查询条件');
						this.$refs.SearchBannerRef.resetSearchParams();
						this.$refs.SearchBoxRef.clearAllSelections();
						this.resetSearchBannerParams();
						this.resetSearchBoxParams();
						this.$store.dispatch('Settings/setResetStandardsList', false);
						// this.getAllStandardBasicInfo();
						if (this.categoryType == 1) {
							this.getAllStandardBasicInfo();
						} else {
							this.getNormStandardBasicInfo();
						}
					});
				}
			},
			uisLogin(newVal, oldVal) {
				// this.getAllStandardBasicInfo();
			},

			cinfo() {
				this.getAllStandardBasicInfo();
			}
		}
	};
</script>

<style lang="less" scoped>
	// ========== 绿色横幅 - 1:1 匹配 lz_project store green gradient banner ==========
	.searchbanner {
		// from-green-600 to-emerald-600
		background: linear-gradient(to right, rgb(0, 166, 61), rgb(0, 153, 102));
		color: #ffffff;
		padding: 32px 0;

		.banner-content {
			width: 78%;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;
		}

		.banner-left {
			flex: 0 0 auto;
		}

		.banner-right {
			flex: 1;
			text-align: center;
		}

		.banner-desc {
			font-size: 17px;
			color: rgba(255, 255, 255, 1);
			line-height: 1.6;
			margin: 0;
		}

		.banner-title {
			font-size: 20px;
			font-weight: 700;
			margin-bottom: 4px;
			line-height: 1.3;
			margin-top: 0;
		}

		.banner-subtitle {
			font-size: 14px;
			color: rgba(255, 255, 255, 0.8);
			line-height: 1.5;
			margin: 0;
		}
	}

	.shop {
		padding-bottom: 24px;
	}

	.dataList {
		width: 80%;
		min-height: calc(100vh - 660px);
		margin: 0 auto;
		margin-top: 24px;
	}
	//媒体查询-pad
	@media screen and (min-device-width: 768px) and (max-device-width: 1024px) {
		.dataList {
			width: 96%;
		}
		.searchbanner {
			.banner-content {
				width: 96%;
			}
		}
	}
	@media screen and (max-width: 767px) {
		.shop .dataList .el-row {
			flex-direction: column;
		}
		.shop .dataList .el-col-6 {
			width: 100%;
		}
		.shop .dataList .el-col-18 {
			width: 100%;
		}
		.searchbanner {
			padding: 20px 0;
		}
		.searchbanner .banner-title {
			font-size: 18px;
		}
		.searchbanner .banner-subtitle {
			font-size: 12px;
		}
		.searchbanner .banner-right {
			display: none;
		}
	}
</style>
